import {createRouter, createWebHistory} from "vue-router";

const HomeUaa = () => import('@/containers/HomeUaa.vue');
const PerguntasFrequentes = () => import('@/containers/PerguntasFrequentes.vue');
const AvisosComunicados = () => import('@/containers/AvisosComunicados.vue');
const CandidaturasResultados = () => import('@/containers/CandidaturasResultados.vue');
const DocumentacaoAcademica = () => import('@/containers/DocumentacaoAcademica.vue');
const EstudanteInternacional = () => import('@/containers/EstudanteInternacional.vue');
const ProvasAcademicas = () => import('@/containers/ProvasAcademicas.vue');
const ReconhecimentoDiploma = () => import('@/containers/ReconhecimentoDiploma.vue');
const AvisosComunicadosDetalhe = () => import('@/containers/AvisosComunicadosDetalhe.vue');
const EiContent = () => import('@/components/EiContent.vue');
const RDContent = () => import('@/components/RDContent.vue');

let baseUrl = window.currentLanguage == "en" ?
import.meta.env.VITE_APP_BASEURLEN : 
import.meta.env.VITE_APP_BASEURL;

const router =  createRouter({
  routes:[
      { path:'/', component: HomeUaa },
      { path:'/faq', component: PerguntasFrequentes },
      { path:'/avisos/:id', component: AvisosComunicadosDetalhe },
      { path:'/avisos', component: AvisosComunicados },
      { path:'/candidaturas', component: CandidaturasResultados },
      { path:'/documentacao', component: DocumentacaoAcademica, name:"documentacaoacademica" },
      {   path:'/estudanteinternacional', 
          component: EstudanteInternacional,
          children:[
              {  path: '', redirect: "/estudanteinternacional/concurso" },
              {  path: ':id', component: EiContent }
          ]
      },
      { path:'/provas', component: ProvasAcademicas },
      { 
          path:'/diplomas', component: ReconhecimentoDiploma,
          children:[
              { path: '', redirect: "/diplomas/tipodereconhecimento" },
              { path: ':id', component: RDContent }
          ]
      }
  ],
  history: createWebHistory(baseUrl),
  scrollBehavior() {
      // always scroll to top
      return { top: 0 }
  },
})

export default router;